// extracted by mini-css-extract-plugin
module.exports = {"container":"TrustSignals_container__DhnCn","item":"TrustSignals_item__UlHKB","itemLink":"TrustSignals_itemLink__SQ5QW","itemText":"TrustSignals_itemText__S0e5R"};